
    import { Vue, Component, Prop } from 'vue-property-decorator'

    @Component
    export default class TwoFactorActionFooter extends Vue {
        @Prop({ type: String, default: 'twofactor-action-footer' }) footerClass!: string
        @Prop({ type: Boolean, default: true }) showBackButton!: boolean
        @Prop({ type: String, default: () => '' }) backButtonText!: string
        @Prop({ type: String, required: true }) primaryButtonText!: string
        @Prop({ type: String, default: 'accent' }) primaryButtonColor!: string
        @Prop({ type: String, default: '' }) primaryButtonIcon!: string
        @Prop({ type: String, default: '' }) primaryButtonIconRight!: string
        @Prop({ type: Boolean, default: false }) isPrimaryButtonActive!: boolean
        @Prop({ type: Boolean, default: false }) isDisabled!: boolean
        @Prop({ type: Boolean, default: false }) loading!: boolean
    }
